import type { FC, Dispatch, ReactNode } from 'react';
import { useReducer, createContext } from 'react';
import type { Action, WidgetState } from './types';
import { initialState } from './initialState';
import { reducer } from './WidgetContext';

export const WidgetContext = createContext<[WidgetState, Dispatch<Action>]>([initialState, () => undefined]);

interface Props {
    children: ReactNode;
     
    state?: typeof initialState;
     
    dispatch?: Dispatch<Action>;
}

export const WidgetContextProvider: FC<Props> = ({ children, state: bootstrappedState = initialState }) => {
    const [state, dispatch] = useReducer(reducer, bootstrappedState);

    return <WidgetContext.Provider value={[state, dispatch]}>{children}</WidgetContext.Provider>;
};

export const TestWidgetContextProvider: FC<Props> = ({
    children,
    state: bootstrappedState = initialState,
    dispatch = () => undefined,
}) => <WidgetContext.Provider value={[bootstrappedState, dispatch]}>{children}</WidgetContext.Provider>;
